import axios from 'axios';

import { Team } from './types';

// Includes both MLB and MiLB teams
export const WITH_MiLB_SPORT_IDS = [1, 11, 12, 13, 14];

export async function getTeams(baseURL: string, sportIds = [1]): Promise<Team[]> {
  const response = await axios.get(
    `${baseURL}/teams?sportIds=${sportIds.join(',')}&season=${new Date().getFullYear()}&fields=teams,id,venue,teamName,abbreviation,name&allStarStatuses=Y,N`,
  );
  return response.data.teams;
}
